export const HEADER_SIZE_MD = "30px";
export const HEADER_SIZE_LG = "40px";

export const WINDOW_CONTROLS_WIDTH = "10.5rem";
